import { StyledMultiFileDropZone } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/styled';
import { ACCEPT_FILES_TYPES } from '@dealstack/frontend/shared/components/MultiFileDropZone/MultiFileDropZone';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	DataKYCFileTctWithFile,
	GetKYCInvestorInstanceRes,
	KYCFileType,
} from '@dealstack/shared/lib/generated';
import { Step } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { onUploadedAndFileAssociated } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/ReviewFiles/utils/onUploadedAndFileAssociated';
import { useKycFileUploadAndAssociate } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/api/useKycFileUploadAndAssociate';
import { useManageKYCController } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/useManageKYCController';
import { useSearchParams } from 'react-router-dom';

interface Props {
	currentStep?: Step;
	currentInvestor?: GetKYCInvestorInstanceRes;
	selectedKycFile?: DataKYCFileTctWithFile;
	templateIdOverride?: string;
	typeOverride?: KYCFileType;
	primaryText?: string;
}

export const AddKycFileButton = ({
	currentStep,
	currentInvestor,
	selectedKycFile,
	templateIdOverride,
	typeOverride,
	primaryText,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const [searchParams] = useSearchParams();
	const kycWorkflowId = searchParams.get('kycWorkflowId') ?? undefined;
	const { getKYCDataRequest } = useManageKYCController(currentInvestor?.id, kycWorkflowId);

	const onUploadedAndFileAssociatedSuccess = onUploadedAndFileAssociated(
		tMipManage,
		getKYCDataRequest
	);

	const { uploadFile, isLoading: isUpdating } = useKycFileUploadAndAssociate({
		selectedKycFile,
		currentInvestor,
		currentStep,
		kycWorkflowId,
		typeOverride,
		onUploadedAndFileAssociatedSuccess,
	});

	return (
		<StyledMultiFileDropZone
			primaryText={primaryText ?? tMipManage('kyc.review.add_file')}
			loading={isUpdating}
			minWidth="100%"
			size="STD"
			disabled={false}
			onDropFile={async (file) => {
				uploadFile(file[0], { templateIdOverride });
			}}
			multiple={false}
			accept={ACCEPT_FILES_TYPES.imagesAndPdf}
		/>
	);
};
